import { render } from "./leadDetail.vue?vue&type=template&id=1b709510&scoped=true"
import script from "./leadDetail.vue?vue&type=script&lang=js"
export * from "./leadDetail.vue?vue&type=script&lang=js"

import "./leadDetail.vue?vue&type=style&index=0&id=1b709510&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b709510"]])

export default __exports__